import { IntegrationScreen } from '../features/integrations/IntegrationScreen'
import { useShell } from '../app/outlet'

export function IntegrationPage() {
  const { toast } = useShell()
  return <IntegrationScreen onToast={toast} />
}
